module.exports = __webpack_public_path__ + "img/effect.b66c6c3e.png";